// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, filter, map, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';
import { getPublicationListFailed, getPublicationListRequested, getPublicationListSucceeded } from './select-publication.actions';
import { DictionariesService } from '@par/app/core/data-services/dictionaries.service';
import { Store } from '@ngrx/store';
import { selectPublicationListResponse } from './select-publication.selectors';

@Injectable()
export class SelectPublicationEffects {

  listRequested$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getPublicationListRequested),
      withLatestFrom(this.store.select(selectPublicationListResponse)),
      filter(([, response]) => response == null),
      exhaustMap(() => this.service.getPublicationList()
        .pipe(
          map((response) => getPublicationListSucceeded({response})),
          catchError(() => of(getPublicationListFailed())),
        )),
    ),
  );

  constructor(
    private actions$: Actions,
    private service: DictionariesService,
    private store: Store,
  ) {
  }
}
